import { useEffect, useRef, useState } from 'react';
import { api } from './api';
type Listing = {path:string;parent:string|null;folders:{name:string;path:string}[];roots:{name:string;path:string}[]};
export function FolderPicker({ initialPath, onClose, onSelect }: {initialPath:string;onClose:()=>void;onSelect:(folder:string)=>void}) {
  const dialog = useRef<HTMLDialogElement>(null);
  const [listing,setListing]=useState<Listing|null>(null);
  const [error,setError]=useState('');
  const [busy,setBusy]=useState(false);
  const [filter,setFilter]=useState('');
  const sequence=useRef(0);
  async function browse(folder='') {
    const request=++sequence.current;
    setBusy(true);setError('');
    try {
      const result=await api<Listing>('/admin/folders'+(folder?'?path='+encodeURIComponent(folder):''));
      if(request===sequence.current){setListing(result);setFilter('');}
    }catch(e){if(request===sequence.current)setError((e as Error).message);}
    finally{if(request===sequence.current)setBusy(false);}
  }
  useEffect(()=>{dialog.current?.showModal();void browse(initialPath);return()=>{sequence.current++;};},[]);
  return <dialog ref={dialog} className="folder-picker" onCancel={onClose} aria-labelledby="folder-picker-title">
    <div className="folder-picker-heading"><h2 id="folder-picker-title">Choose photo folder</h2><button type="button" onClick={onClose} aria-label="Close folder picker">✕</button></div>
    <p>Browse folders on the computer running Photo Wall.</p>
    <div className="folder-picker-tools"><button type="button" disabled={busy} onClick={()=>void browse()}>Home</button>
      {listing?.roots.filter(r=>r.name!=='Home').map(r=><button type="button" disabled={busy} key={r.path} onClick={()=>void browse(r.path)}>{r.name}</button>)}
      <button type="button" disabled={busy||!listing?.parent} onClick={()=>void browse(listing!.parent!)}>Up one folder</button></div>
    <p className="folder-picker-path">{listing?.path || 'Choose a location'}</p>
    {error && <p role="alert" className="error">{error}</p>}
    <label>Find a folder<input value={filter} onChange={e=>setFilter(e.target.value)} placeholder="Filter folder names" /></label>
    <div className="folder-picker-list" aria-busy={busy}>
      {busy ? <p>Loading folders…</p> : listing?.folders.filter(f=>f.name.toLowerCase().includes(filter.toLowerCase())).map(f=><button type="button" key={f.path} onClick={()=>void browse(f.path)}>📁 {f.name}</button>)}
      {!busy && listing && !listing.folders.length && <p>No subfolders. You can use this folder.</p>}
    </div>
    <div className="folder-picker-footer"><button type="button" onClick={onClose}>Cancel</button><button type="button" className="primary" disabled={!listing||busy||!!error} onClick={()=>onSelect(listing!.path)}>Use this folder</button></div>
  </dialog>;
}
